<template>
  <div class="subscribed-offer-information q-mx-xl">
    <div v-if="subscribedInformations.getFormattedEndDate()">
      <QIcon name="icon-extra-date" size="lg" color="secondary" />
      <p>{{ $t('ETAB.PAGES.SUBSCRIPTION.@COMMITMENT_END') }}</p>
      <p class="text-bold">
        {{ subscribedInformations.getFormattedEndDate() }}
      </p>
      <p>{{ $t('ETAB.PAGES.SUBSCRIPTION.@ACTIVE_SUBSCRIPTION') }}</p>
    </div>
    <QSeparator v-if="subscribedInformations.getFormattedEndDate()" class="mobile-screens q-my-md" />
    <div>
      <QIcon name="icon-extra-debit" size="lg" color="secondary" />
      <p>{{ $t('ETAB.PAGES.SUBSCRIPTION.@NEXT_DEBIT') }}</p>
      <p class="text-bold">
        {{ subscribedInformations.getFormattedNextPaymentDate() }}
      </p>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p v-html="$t('ETAB.PAGES.SUBSCRIPTION.@NEXT_DEBIT_AMOUNT', { amount: subscribedInformations.getOffer().getAmountLabel() })" />
    </div>
  </div>
</template>

<script>
import { SubscribedInformationsModel } from "@core/models";

export default {
  props: {
    subscribedInformations: {
      type: Object,
      default: () => new SubscribedInformationsModel(),
    },
  },
};
</script>

<style lang="scss" scoped>
.subscribed-offer-information {
  display: flex;
  justify-content: space-around;
  background-color: $superlightgrey;
  padding: 10px;
  text-align: center;
  > div {
    width: 50%;
  }
  @media screen and (max-width: $breakpoint-sm) {
    flex-direction: column-reverse;
    padding: 5px;
    margin: 10px;
    > div {
      width: 100%;
    }
  }
  > div {
    > .q-icon {
      margin-bottom: 10px;
    }
  }
}
</style>
